export enum ResolutionType {
  Feed = 'feed',
  Stories = 'story',
  Youtube = 'youtube',
}

export interface Material {
  _id: string
  name: string
  description?: string
  dateLiberation: Date
  feedImages: string[]
  storyImages: string[]
  youtubeImages: string[]
  thumbnail?: string
  isSellersApp?: boolean
  isTeamsApp?: boolean
}
